import React from 'react';
import { Link } from 'react-router-dom';
import { FaUsers, FaGlobeAmericas, FaPassport, FaGraduationCap, FaArrowRight } from 'react-icons/fa';
import '../styles/ServicesSection.css';

const services = [
  {
    icon: <FaGlobeAmericas />,
    title: 'Global Placements',
    description: 'Connecting world-class talent with international opportunities across diverse sectors and geographies.',
    link: '/services',
    features: ['International Recruitment', 'Cross-Border Hiring', 'Global Talent Network', 'Sector Expertise']
  },
  {
    icon: <FaPassport />,
    title: 'Immigration Services',
    description: 'Managing complex logistics of cross-border employment, facilitating visas, work permits, and relocation support.',
    link: '/services',
    features: ['Visa Processing', 'Work Permits', 'Relocation Support', 'Compliance Management']
  },
  {
    icon: <FaUsers />,
    title: 'Human Resources and Management Efficiency Services',
    description: 'Strategic HR consulting and executive advisory to optimize your workforce, enhance business efficiency, and ensure compliance across all jurisdictions.',
    link: '/services',
    features: ['Organizational Design', 'Leadership Development', 'Performance Management', 'Operational Excellence']
  },
  {
    icon: <FaGraduationCap />,
    title: 'Student Services',
    description: 'Guiding students through international education placement, career planning, and vocational counseling.',
    link: '/services',
    features: ['Education Placement', 'Career Planning', 'Vocational Counseling', 'Institution Selection']
  }
];

const ServicesSection = () => {
  return (
    <section className="services-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Our Services</span>
          <h2 className="section-title">Comprehensive Consultancy Solutions</h2>
          <p className="section-description">
            We offer a cohesive suite of services designed to support businesses, professionals,
            and students navigate the complexities of global expansion, staffing, and education.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
              <Link to={service.link} className="service-link">
                Learn More <FaArrowRight />
              </Link>
            </div>
          ))}
        </div>

      </div>

      <div className="services-cta-background">
        <img
          src="/images/view-all-services.jpeg"
          alt="Global services background"
          className="services-cta-bg-image"
        />
        <div className="services-cta-overlay"></div>
        <div className="container">
          <div className="services-cta">
            <Link to="/services" className="btn btn-primary">
              View All Services <FaArrowRight className="btn-icon" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
